module.exports = __webpack_public_path__ + "static/img/xps.d3986fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_suffix/xps.png
// module id = Xvt2
// module chunks = 53